<!-- demo root element -->
<template>
<section class="content">
  <h3 class="steps-heading clearfix">
    <span>Model Dashboard</span>
  </h3>
  <button @click="showModel('create')" class="btn btn-primary create-model-btn">
    Create New
  </button>
  <CreateModel v-if="showModal" :modelType="modelType" @close="closeModal()" @openModal="ModelCreated"></CreateModel>
  <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  <div class="model-history">
      <h5><strong>Existing Models</strong></h5 >
      <demo-grid
        :data="gridData"
        :columns="gridColumns"
        :filter-key="searchQuery"
        :pagination="pagination"
        :sortKeys="sortKeys"
        @pageChange="pageChange($event, 'pagination')"
        @showModel="showModel">
      </demo-grid>
  </div>
<div class="spinner" style="display:block">
    <div class="loadingtext">{{loadingtext}}</div>
  <div class="loader">Loading...</div>
  </div>
</section>
</template>

<script>
import jQuery from 'jquery'
import DemoGrid from './DemoGrid'
import { mapState } from 'vuex'
import CreateModel from './Create-model.vue'
import Simplert from 'vue2-simplert'

export default {
  name: 'ModelHistory',
  components: { DemoGrid, CreateModel, Simplert },
  data () {
    return {
      loadingtext: '',
      searchQuery: '',
      modelType: '',
      gridColumns: [],
      gridData: [],
      pagination: {
        type: Object,
        default: () => ({})
      },
      dataPage: 10,
      pages: Number,
      showModal: false,
      sortKeys: ['Name', 'Country', 'Category', 'Created By']
    }
  },
  computed: {
    ...mapState([
      'userInfo'
    ]),
    demo () {
      // var usern = localStorage.getItem('username')
      return {
        displayName: localStorage.getItem('username'),
        avatar: '/static/img/stock/user.png',
        email: localStorage.getItem('email'),
        randomCard: ''
      }
    }
  },
  methods: {
    popupnoModel () {
      let popupnoModel = {
        title: 'No Model Present',
        message: 'Click to Create Model',
        type: 'info',
        customCloseBtnClass: 'btn btn-primary',
        onClose: this.closecreate,
        customCloseBtnText: 'Create Model'
      }
      this.$refs.simplert.openSimplert(popupnoModel)
    },
    closecreate () {
      this.showModel('create')
    },
    getData () {
      var self = this
      jQuery.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/GetUserModels',
        data: {'user-id': window.localStorage.getItem('user')},
        async: true,
        contentType: 'application/json',
        headers: { 'x-api-key': window.localStorage.getItem('XpiKey') },
        beforeSend: function () {
          jQuery('.spinner').show()
          self.loadingtext = 'fetching your models...'
          setTimeout(() => {
            self.loadingtext = 'almost done!'
          }, 2000)
        },
        complete: function (data) {
          jQuery('.spinner').hide()
        },
        success: function (data) {
          data = JSON.parse(JSON.stringify(data['output']))
          data['Columns'].splice(5)
          data['Rows'].forEach(function (currentValue, index) {
            delete currentValue.Comments
          })
          self.gridColumns = data['Columns']
          self.gridData = data['Rows']
          var pages = (self.count(self.gridData) / self.dataPage)
          pages = Math.ceil(pages)
          self.pagination = {'totalPages': pages, 'currentPage': 1, 'dataPage': self.dataPage}
          if (data['Rows'].length === 0) {
            self.popupnoModel()
            return
          }
        },
        error: function (data, error) {
          console.log(data)
          console.log(error)
          self.displaydownloadError()
        } })
    },
    count: function count (obj) {
      var count = 0
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          ++count
        }
      }
      return count
    },
    filterData: function () {
      delete self.gridColumns['Columns'][5]
      self.gridData['Rows'].forEach(function (currentValue, index) {
        delete currentValue.Comments
      })
    },
    pageChange (page) {
      this.pagination.currentPage = page
    },
    modelepopuponClose () {
      this.$router.push('/report')
    },
    ModelCreated () {
      let modelCreatedModal = {
        title: 'Model Created',
        message: '',
        type: 'success',
        customCloseBtnClass: 'btn btn-primary',
        onClose: this.modelepopuponClose
      }
      this.$refs.simplert.openSimplert(modelCreatedModal)
    },
    closeModal () {
      if (this.modelType === 'view') {
        this.showModal = false
      } else {
        let that = this
        let confirmCloseModal = {
          title: 'Are you sure you want to close Create Model?',
          type: 'info',
          useConfirmBtn: true,
          customConfirmBtnText: 'Yes',
          customCloseBtnText: 'No',
          customConfirmBtnClass: 'btn btn-primary',
          customCloseBtnClass: 'btn btn-primary',
          onConfirm: function () {
            that.showModal = false
          }
        }
        this.$refs.simplert.openSimplert(confirmCloseModal)
      }
    },
    showModel (type, jobId) {
      this.modelType = type
      this.showModal = true
      if (type === 'view') {
        window.localStorage.setItem('JobId', jobId)
      }
    }
  },
  beforeMount: function () {
    this.getData()
  }
}

</script>

<style>
 section.content{
   padding: 10px 40px;
 }
.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}
.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #fff;
}
.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #fff;
}

.model-history .pointer {
  cursor: pointer;
}
.create-model-btn{
  margin-top: 25px;
}
.btn.btn-primary, .btn-primary:active:focus{
    background: #000;
    border-radius: 6px;
    font-weight: bold;
    font-size: 15px;
    border-color:#000;
    margin-right:15px;
}
.model-history {
    margin-top: 60px;
}
.model-history table {
    width: 100%;
}
.model-history tr th, .model-history tr td {
    padding: 5px 10px;
    background-color: #f1b828;
    color: #000;
    border: 1px solid #fff;
}
.model-history tr th, .model-history .first-col {
    color: #fff;
    background-color: #000;
    font-size: 16px;
}
.content-wrapper .simplert {
    z-index: 9999;
}
/* Modal CSS*/
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  position: relative;
  vertical-align: top;
}

.modal-container {
  width: 80%;
  margin:50px auto 0;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  height: 90%;
  overflow-y: scroll;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.model-name {
  vertical-align: middle;
  padding: 5px 40px 5px 0;
  position: relative;
}
.model-name span {
    font-weight: bold;
}
.model-history td:hover .model-name svg {
    display: inline-block;
}
button.btn.btn-secondary.view-btn {
    line-height: 1;
    position: absolute;
    right: 0;
    top: 50%;
    margin-top: -14px;
    background: #000;
    color: #fff;
    padding: 2px 4px;
    font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// Model-history.vue?7901068c